<template>
  <div>
    <h4>Задания учителя</h4>
    <work-self :id="id" />

    <!-- <h4>Общие задания</h4>
    <work-global :id="id" /> -->
  </div>
</template>
<script>
import WorkSelf from "./WorkSelf.vue";
import WorkGlobal from "./WorkGlobal.vue";
export default {
  components: { WorkSelf, WorkGlobal },
  name: "products",
  props: ["id"],
  created() {
    //надо получить группу!
    this.itemLink = `business/timetables/${this.id}/works`;
    this.setLink = `business/timetables/${this.id}/works`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      loadingStatus: null,
      val: [],
      modalCreate: "client_group",
      fields: [
        {
          col: "col-12 col-md-8",
          key: "title",
          label: "Название",
          type: "field",
          textType: "text",
        },

        {
          col: "col-12 col-md-4",
          key: "given_seconds",
          label: "Сколько секунд на решение",
          type: "mask",
          mask: "###",
          textType: "number",
        },
        {
          col: "col-12 col-md-12",
          key: "description",
          label: "Краткое описание задания",
          type: "textarea",
          textType: "text",
        },
        {
          col:'col-12 col-md-12',
          key: "autocheck",
          label: "Автопроверка",
          type: "checkbox",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_work",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "title",
          title: "Задание",
          checkbox: false,
        },

        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
